import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, take } from 'rxjs';

type ResourceType = 'task' | 'req';

@Component({
  selector: 'app-resource-link',
  templateUrl: './resource-link.component.html',
  styleUrls: ['./resource-link.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResourceLinkComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    combineLatest([this.route.paramMap, this.route.queryParamMap, this.route.data])
      .pipe(take(1))
      .subscribe(([params, queryParams, data]) => {
        const resourceId = String(params.get('id') ?? '').trim();

        if (resourceId.length === 0) {
          this.router.navigate(['/translogs']);

          return;
        }

        const transactionId = String(queryParams.get('transactionId') ?? '').trim();
        const resourceType = this.getResourceType(data['resourceType']);

        this.router.navigateByUrl(this.buildRedirectUrl(resourceType, resourceId, transactionId), {
          replaceUrl: true
        });
      });
  }

  private buildRedirectUrl(
    resourceType: ResourceType,
    resourceId: string,
    transactionId: string
  ): string {
    const targetPath =
      resourceType === 'task'
        ? `/tasks/${encodeURIComponent(resourceId)}`
        : `/req/${encodeURIComponent(resourceId)}`;
    const params = new URLSearchParams();

    if (transactionId.length > 0) {
      params.set('transactionId', transactionId);
    }

    const queryString = params.toString();

    return queryString.length > 0 ? `${targetPath}?${queryString}` : targetPath;
  }

  private getResourceType(value: unknown): ResourceType {
    return value === 'req' ? 'req' : 'task';
  }
}
